import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import validateProduct from '../services/HiddenProducts';
import { useTranslation } from 'react-i18next';
import { showErrorAlert } from '../alerts/Error';

const ProductGuard = ({ idproduct, children }) => {
  const [hiddenProduct, setHiddenProduct] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const Swal = require('sweetalert2')

  useEffect(() => {
    const controller = new AbortController();

    const fetchHiddenProducts = async () => {
      if (idproduct != null) {
        try {
          const response = await validateProduct(idproduct);
          console.log(response)
          if (response.data.result == 'success') {
              setHiddenProduct(true)
          }
        } catch (error) {
          console.error("Error fetching hidden products", error);
        }
      }
      
    };

    fetchHiddenProducts();

    return () => controller.abort();
  }, []);

  useEffect(() => {
   
    console.log("idproduct")
    console.log(idproduct)
    if (hiddenProduct) {
        const timer = setTimeout(() => { navigate('/checkout', { replace: true });}, 3000);
        Swal.fire({ title: t("cart.hidden.error.title"), text: t("cart.hidden.error.text"), 
          icon: 'error', showConfirmButton: false,timer: 3000, 
            },
          timer);
        
    }
  }, [hiddenProduct, navigate]);

  //Retorna children para permitir que Cart.js se renderice
  return <>{children}</>;

};

export default ProductGuard;
